/**
 * LWR — Estocástico Rápido Invertido Suavizado.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.LWR). Painel próprio, 2 linhas, escala 0–100:
 *
 *   RSV  = (HHV(H,N) − C) / (HHV(H,N) − LLV(L,N)) * 100   (Estocástico Rápido INVERTIDO)
 *   LWR1 = SMA(RSV,  M1, 1)
 *   LWR2 = SMA(LWR1, M2, 1)
 *
 * SMA(x,N,1) é a "SMA chinesa" (Wilder com seed de média simples) — ver
 * silverlightDsl.js. Paridade provada em __tests__/lwr.silverlight.test.js.
 */
import { hhv, llv, sub, div, mul, sma } from "./silverlightDsl";
import { LWR as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, m1, m2 } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));
    const close = data.map((d) => num(d.close));

    const hh = hhv(high, period);
    const ll = llv(low, period);
    const rsv = mul(div(sub(hh, close), sub(hh, ll)), 100);
    const lwr1 = sma(rsv, m1, 1);
    const lwr2 = sma(lwr1, m2, 1);

    return lwr1.map((v, i) => {
      const l1 = Number.isFinite(v) ? v : undefined;
      const l2 = Number.isFinite(lwr2[i]) ? lwr2[i] : undefined;
      if (l1 === undefined && l2 === undefined) return undefined;
      return { lwr1: l1, lwr2: l2 };
    });
  }

  calculator.undefinedLength = function () {
    const { period, m1, m2 } = options;
    // RSV acumula N-1; LWR1 acrescenta M1-1; LWR2 acrescenta M2-1.
    return Math.max(0, period - 1 + (m1 - 1) + (m2 - 1));
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
